export function PostAge(createdAt: string): string {
  const hourInMillisecond = 1000 * 60 * 60;
  const minuteInMillisecond = 1000 * 60;
  const dayInMillisecond = 1000 * 60 * 60 * 24;

  const createdDate = new Date(createdAt.toString());
  const todaysDate = new Date();

  const differenceInMillisecond = todaysDate.getTime() - createdDate.getTime();

  if (differenceInMillisecond < hourInMillisecond) {
    return `${Math.floor(differenceInMillisecond / minuteInMillisecond)}m`;
  }
  if (differenceInMillisecond < dayInMillisecond) {
    return `${Math.floor(differenceInMillisecond / hourInMillisecond)}h`;
  }
  return `${Math.floor(differenceInMillisecond / dayInMillisecond)}d`;
}

export function DateTransformation(createDate: string): string {
  const date = new Date(createDate.toString());
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${month} ${day}, ${year}`;
}

export function timeAgoDescription(createdAt: string): string {
  const millisecondsPerHour = 1000 * 60 * 60;
  const millisecondsPerMinute = 1000 * 60;
  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const createdDate = new Date(createdAt);
  const todaysDate = new Date();

  const differenceInMillisecond = todaysDate.getTime() - createdDate.getTime();

  if (differenceInMillisecond < millisecondsPerHour) {
    return `${Math.floor(differenceInMillisecond / millisecondsPerMinute)}m`;
  }
  if (differenceInMillisecond < millisecondsPerDay) {
    return `${Math.floor(differenceInMillisecond / millisecondsPerHour)}h`;
  }
  return `${Math.floor(differenceInMillisecond / millisecondsPerDay)}d`;
}

export function durationDescription(durationInSeconds: number): string {
  const secondsPerMinute = 60;
  const secondPerHour = 60 * 60;

  let remainingDuration = durationInSeconds;

  const hours = Math.floor(remainingDuration / secondPerHour);
  remainingDuration -= hours * secondPerHour;
  const hoursString = `${hours}`;

  const minutes = Math.floor(remainingDuration / secondsPerMinute);
  remainingDuration -= minutes * secondsPerMinute;
  const minutesString = `${minutes}`;

  const seconds = Math.floor(remainingDuration);
  remainingDuration -= seconds;
  const secondsString = seconds.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

  let timeComponents: string[];
  if (hours > 0) {
    timeComponents = [hoursString, minutesString, secondsString];
  } else {
    timeComponents = [minutesString, secondsString];
  }

  return timeComponents.join(":");
}
